;(function() {
  'use strict';

  angular
    .module('pub.shinies.odds.service', [])
    .factory('ShiniesOddsService', ShiniesOddsService);

  /** @ngInject */
  function ShiniesOddsService($http, $q, API) {

    function list(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/shinies/' + id + '/shiny_odds')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function save(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'publisher/shinies/' + id + '/shiny_odds', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'publisher/shiny_odds/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'publisher/shiny_odds/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      list: list,
      save: save,
      remove: remove,
      update: update,
    };

  }

})();
